import {
  FETCH_REPORT_BY_ID_REQUEST,
  FETCH_REPORT_BY_ID_RESPONSE,
  FETCH_REPORT_BY_ID_ERROR,
  FETCH_REPORT_DATA_RESPONSE,
  FETCH_REPORT_DATA_REQUEST,
  FETCH_REPORT_DATA_ERROR,
  RESET_REPORT_DATA_VIEWS,
  UPDATE_TABLE_CONFIG,
  UPDATE_REPORTING_TYPE_IDS,
} from './actionTypes';

const tableConfig = {
  page: 1,
  pageSize: 10,
  filter: '',
};

const initialState = {
  dateTimeViewData: [],
  summaryViewData: {
    data: [],
  },
  tableConfig,
};

const reportTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REPORT_BY_ID_REQUEST:
    case FETCH_REPORT_DATA_REQUEST: {
      return {
        ...state,
        loadingData: true,
      };
    }
    case FETCH_REPORT_DATA_RESPONSE: {
      return {
        ...state,
        loadingData: false,
        dateTimeViewData: action.reportData.dateTimeViewMetrics,
        summaryViewData: {
          data: action.reportSummaryData.campaignViewMetrics,
        },
      };
    }
    case UPDATE_TABLE_CONFIG: {
      return {
        ...state,
        tableConfig: action.tableConfig,
      };
    }
    case UPDATE_REPORTING_TYPE_IDS: {
      return {
        ...state,
        tableConfig: {
          ...state.tableConfig,
          page: 1,
        },
      };
    }
    case FETCH_REPORT_BY_ID_RESPONSE:
    case FETCH_REPORT_BY_ID_ERROR:
    case FETCH_REPORT_DATA_ERROR: {
      return {
        ...state,
        loadingData: false,
      };
    }
    case RESET_REPORT_DATA_VIEWS: {
      return {
        ...state,
        dateTimeViewData: initialState.dateTimeViewData,
        summaryViewData: initialState.summaryViewData,
        tableConfig,
      };
    }
    default: {
      return state;
    }
  }
};

export default reportTableReducer;
